<template lang="pug">
.h-173
  //- small {{ details }}
  swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
    template(v-if="isShow")
      swiper-slide.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
        .match-bet-area-group.flex-grow-2
          hdpItem(:details="details" :oddsType="oddsType" betType="hdp" homeAway="1")
        .match-bet-area-group.flex-grow-2
          ouItem(:details="details" :oddsType="oddsType" betType="ou")
        .match-bet-area-group.flex-grow-1
          oxtItem(:details="details" :oddsType="oddsType" betType="oxt")
      template(v-if="source.details.hdph || source.details.ouh || source.details.oxth")
        swiper-slide.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
          template(v-if="activeIndex == 1")
            .match-bet-area-group.flex-grow-2
              hdpItem(:details="details" :oddsType="oddsType" betType="hdph" homeAway="2")
            .match-bet-area-group.flex-grow-2
              ouItem(:details="details" :oddsType="oddsType" betType="ouh")
            .match-bet-area-group.flex-grow-1
              oxtItem(:details="details" :oddsType="oddsType" betType="oxth")
    .swiper-pagination(slot="pagination")

  //- .swiper(ref="sw")
  //-   .swiper-slide.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
  //-     .match-bet-area-group.flex-grow-2
  //-       hdpItem(:details="details" :oddsType="oddsType" betType="hdp" homeAway="1")
  //-     .match-bet-area-group.flex-grow-2
  //-       ouItem(:details="details" :oddsType="oddsType" betType="ou")
  //-     .match-bet-area-group.flex-grow-1
  //-       oxtItem(:details="details" :oddsType="oddsType" betType="oxt")
  //-   template(v-if="source.details.hdph || source.details.ouh || source.details.oxth")
  //-     .swiper-slide.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
  //-       .match-bet-area-group.flex-grow-2
  //-         hdpItem(:details="details" :oddsType="oddsType" betType="hdph" homeAway="2")
  //-       .match-bet-area-group.flex-grow-2
  //-         ouItem(:details="details" :oddsType="oddsType" betType="ouh")
  //-       .match-bet-area-group.flex-grow-1
  //-         oxtItem(:details="details" :oddsType="oddsType" betType="oxth")
  //-   .swiper-pagination(slot="pagination")
</template>

<script>
import hdpItem from "@/components/mobile/main/xitem/hdpItem";
import ouItem from "@/components/mobile/main/xitem/ouItem";
import oxtItem from "@/components/mobile/main/xitem/oxtItem";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    hdpItem,
    ouItem,
    oxtItem
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      isShow: false,
      showing: 10
    };
  },
  computed: {
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    }
  },
  mounted() {
    this.activeIndex = this.swiper.activeIndex;
    if (this.source.matchIndex <= this.showing) {
      this.isShow = true;
    } else {
      setTimeout(() => {
        this.isShow = true;
      }, this.source.matchIndex * 25);
    }
  },
  methods: {
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    }
  }
};
</script>
